import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { AUTHOR_URL, authorQuestions } from '../../data/content';
export function Author() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-90" data-mp="1hpo9bzcf0cxs">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-91" data-mp="1wgx40mv6cohs">
        <div className="mx-auto w-full max-w-sm overflow-hidden rounded-3xl bg-[#EAF3FF] lg:max-w-none" data-id="element-92" data-mp="1roxapd9m0tu6">
          <img src={AUTHOR_URL} alt="Dr. Valeria Montes in her orthodontic clinic" className="aspect-[4/5] h-auto w-full object-cover object-top" loading="lazy" data-id="element-93" data-mp="25g24hyqaqrwl" />
        </div>
        <div data-id="element-94" data-mp="2fdgi7qku52l7">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-electric sm:text-sm" data-id="element-95" data-mp="2aggdbizq25vo">About the author</p>
          <h2 className="mt-3 font-display text-[36px] font-black leading-none tracking-tight text-white sm:text-5xl" data-id="element-96" data-mp="l18mib0owhod">
            Dr. Valeria Montes
          </h2>
          <p className="mt-2 font-display text-sm font-extrabold uppercase tracking-wide text-electric-light" data-id="element-97" data-mp="g4i61mkz3k2f">
            Creator of the Orthodontic Torque Control Blueprint™
          </p>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-98" data-mp="3kg7o6kffggeu">
            <p data-id="element-99" data-mp="3pdpzuiktx9qj">When you’re planning orthodontic treatment, understanding the mechanics behind tooth movement is essential.</p>
            <p data-id="element-100" data-mp="3u7lsd5ibq4eb">
              I know how important it is to have clear educational resources when reviewing complex clinical concepts.
              That’s why I want this blueprint to focus on the practical questions that matter when evaluating torque
              control:
            </p>
          </div>
          <ul className="mt-6 space-y-3" data-id="element-101" data-mp="gz8y9tpb1xsg">
            {authorQuestions.map(q => <li key={q} className="border-l-4 border-electric bg-white/5 py-3 pl-4 pr-3 font-display text-lg font-bold text-white" data-id="element-102" data-mp="gwv6putu33pn">
                {q}
              </li>)}
          </ul>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-103" data-mp="2isfb01dmgvy3">
            <p data-id="element-104" data-mp="3m3cp08atlbxj">
              Throughout this library, you’ll find visual explanations, structured decision frameworks, and practical
              learning tools focused on orthodontic torque mechanics.
            </p>
            <p className="text-white" data-id="element-105" data-mp="3q3d13mag5b1f">
              My goal is to help you approach these concepts with greater clarity and strengthen the reasoning behind
              your clinical decisions.
            </p>
          </div>
          <p className="mt-6 font-display text-2xl font-bold italic text-electric-light" data-id="element-106" data-mp="3utzr6cbp0ou">— Dr. Valeria Montes</p>
        </div>
      </div>
      <SectionCTA label="Learn with Dr. Montes today" data-id="element-107" data-mp="hpe88tiru5s5" />
    </section>;
}